import Store from "./Store";
import { computed } from "mobx";
export default class DataSet {
  store: Store;
  data: number[] = [];
  dataP: number[] = [];
  deltas: number[] = [];
  deltasP: number[] = [];

  constructor(store: Store, data: number[], makeCumulative: boolean = false) {
    this.store = store;
    if (makeCumulative) {
      for (let i = 0; i < data.length; i++) {
        if (i !== 0) {
          data[i] = data[i] + data[i - 1];
        }
      }
    }
    this.calc(data);
  }

  @computed get total() {
    return this.data[this.store.activeIndex];
  }

  @computed get totalP() {
    return this.dataP[this.store.activeIndex];
  }

  @computed get delta() {
    return this.deltas[this.store.activeIndex];
  }

  @computed get deltaP() {
    return this.deltasP[this.store.activeIndex];
  }

  calc(data) {
    this.data = data;
    this.dataP = data.map((t, n) => {
      if (n > 0) {
        let p = data[n - 1];
        if (p === 0) return 0;
        let v = t / p - 1;
        let result = Math.round(v * 100);
        return result;
      }
      return 0;
    });

    this.deltas = [...data];
    for (let i = data.length - 1; i >= 0; i--) {
      if (i - 1 >= 0) {
        this.deltas[i] = data[i] - data[i - 1];
      } else {
        this.deltas[i] = 0;
      }
    }

    this.deltasP = this.deltas.map((t, n) => {
      if (n > 0) {
        let p = this.deltas[n - 1];
        if (p === 0) return 0;
        let v = t / p - 1;
        let result = Math.round(v * 100);
        return result;
      }
      return 0;
    });
  }
}
